import type { BlogPost } from '@kkf/design'
import { POSTS as PARSED } from 'virtual:blog-posts'

/**
 * King of Kings Garage's share of the blog.
 *
 * **The blog is one library on four sites as of 2026-09-21.** The markdown is
 * `content/blog/*.md` at the repository root, beside `assets/media/` and for the same
 * reason: four copies of a post are four posts that drift. `tools/vite-blog.ts` reads,
 * front-matter-parses and schema-validates it in Node at build time and serves the result
 * through `virtual:blog-posts`.
 *
 * **This app takes the posts tagged for it** — see `blogContent({ tags })` in
 * `vite.config.ts`, which is where the list lives, because filtering happens at build time
 * and the runtime never needs to know what was asked for. They are the workshop's own work — the trade, the apprentices, and the men who taught them.
 *
 * **An empty list is legitimate here and is not an error.** The Foundation writes about
 * this venture when there is something to write about, and `BlogIndex` says so on the page.
 * Throwing would take a whole site down over a post nobody has written.
 */
export const POSTS = PARSED as BlogPost[]
